// extracted by mini-css-extract-plugin
export default {"pageWrap":"be-z","fullWidth":"ce-z","heading":"de-z","fullBleed":"ee-z","hidden":"fe-z"};